import { createCrudActions } from '../utils/crudGenerator';

const formatShifttypes = (data) => {
    if (!data) {
        return [];
    }
    const formatItem = (item) => ({
        ...item,
        label: `${item.name}`,
        value: item._id,
    });

    if (Array.isArray(data)) {
        return data.map(formatItem);
    }
    return formatItem(data);
};

export const {
    fetch: fetchShifttypes,
    create: createShifttype,
    update: updateShifttype,
    delete: deleteShifttypes
} = createCrudActions('SHIFTTYPE', "Tipo de turno", formatShifttypes);